<template>
  <v-app id="keep">
    <img src="@/assets/PdSM.svg" class="hidden-md-and-up" style="width: 100%;">
    <img src="@/assets/PUBLICACIONESWEB.svg" class="hidden-sm-and-down">
    <!-- <div class="hidden-sm-and-down" style="text-align: center; margin-top: -79px;margin-bottom: 11px;">
      <v-toolbar-title style="margin-left:15px;">
        <span class="" style="color:#222222 ;font-weight: bold;font-family: Georgia, 'Book Antiqua', serif;font-size:25px;">
          PODER JUDICIAL DEL ESTADO DE JALISCO
        </span><br/>
        <v-divider inset></v-divider>
        <span class="" style="color:#222222 ;font-weight: bold;font-family: Georgia, 'Book Antiqua', serif;font-size:18px">
          PUBLICACIÓN DE SENTENCIAS
        </span>
        <br>
      </v-toolbar-title>
    </div> -->
    <div>
      <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      dark
      dense
      color="#373736"
      >
        <v-btn icon to="/">
          <v-icon>mdi-home</v-icon>
        </v-btn>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              href="https://stjjalisco.gob.mx/" target="_blank"
            >
              <img src="@/assets/Escudo-logo.svg" width="33" height="33" />
            </v-btn>
          </template>
          <span>Ir al Sitio web del Supremo Tribunal de Justicia del Estado de Jalisco</span>
        </v-tooltip>

        <div v-if="isLoggedIn" class="d-none d-sm-flex">
          <v-btn class="ml-2" to="/sentencias" color="#373736">
            SENTENCIAS
          </v-btn>
          <v-btn
            class="ml-2 d-sm-and-down"
            v-if="currentUser.roles[0].id == 1 || currentUser.roles[0].id == 2"
            to="/reporte"
            color="#373736"
          >
            REPORTE
          </v-btn>
          <!-- <v-btn
            class="ml-2 d-sm-and-down"
            v-if="currentUser.roles[0].id == 1 || currentUser.roles[0].id == 2"
            to="/estadisticas"
            color="#373736"
          >ESTADISTICAS</v-btn> -->
          <div>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ml-2"
                  v-if="currentUser.roles[0].id == 1 || currentUser.roles[0].id == 2"
                  color="#373736"
                  v-bind="attrs"
                  v-on="on">
                  ESTADÍSTICAS
                </v-btn>
              </template>
              <v-list v-if="currentUser.roles[0].id == 1 ">
                <v-list-item v-for="(menu, i) in itemsEstadisticas" :key="i" link :to="menu.link">
                  <v-list-item-title v-text="menu.text"></v-list-item-title>
                </v-list-item>
              </v-list>
              <v-list v-else>
                <v-list-item link to="/estadisticas">
                  <v-list-item-title>SENTENCIAS PUBLICADAS</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <div>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ml-2"
                  v-if="currentUser.roles[0].id == 1 || currentUser.roles[0].id == 2"
                  color="#373736"
                  v-bind="attrs"
                  v-on="on">
                  CATÁLOGOS
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-if="currentUser.roles[0].id == 1" to="/users">
                  USUARIOS
                </v-list-item>
                <v-list-item v-for="(menu, i) in itemsCatalogo" :key="i" link :to="menu.link">
                  <v-list-item-title v-text="menu.text"></v-list-item-title>
                </v-list-item>
                <!-- <v-list-item v-if="currentUser.roles[0].id == 1" to="/cambios-magistrado">
                  CAM MAG
                </v-list-item> -->
              </v-list>
            </v-menu>
          </div>

          <!-- MENÚ RESUMEN IA - Solo superadmin -->
          <div>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ml-2"
                  v-if="currentUser.roles[0].id == 1"
                  color="#373736"
                  v-bind="attrs"
                  v-on="on">
                  RESUMEN IA
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(menu, i) in itemsResumenIA" :key="i" link :to="menu.link">
                  <v-list-item-title v-text="menu.text"></v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <!-- <v-btn
            class="ml-2"
            v-if="currentUser.roles[0].id == 1 || currentUser.roles[0].id == 2"
            to="/users"
            color="#373736"
          >USUARIOS</v-btn>
          <v-btn
            class="ml-2"
            v-if="currentUser.roles[0].id == 1 || currentUser.roles[0].id == 2"
            to="/delitos"
            color="#373736"
          >DELITOS</v-btn>
          <v-btn
            class="ml-2"
            v-if="currentUser.roles[0].id == 1 || currentUser.roles[0].id == 2"
            to="/tipo-juicios"
            color="#373736"
          >TIPO JUICIOS</v-btn>
          <v-btn
            class="ml-2"
            v-if="currentUser.roles[0].id == 1 || currentUser.roles[0].id == 2"
            to="/sentidos"
            color="#373736"
          >Sentidos</v-btn> -->
        </div>
        <v-menu
          v-if="isLoggedIn && (currentUser.roles[0].id == 1 || currentUser.roles[0].id == 2)"
          bottom
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="d-flex d-sm-none"
              color="#373736"
              dark
              v-bind="attrs"
              v-on="on"
            >MENÚ</v-btn>
          </template>
          <v-list>
            <v-list-item to="/sentencias" class="caption">
              <b>SENTENCIAS</b>
            </v-list-item>
            <v-list-item to="/reporte" class="caption">
              <b>REPORTE</b>
            </v-list-item>
            <v-list-item v-if="currentUser.roles[0].id == 1" to="/users" class="caption">
              <b>USUARIOS</b>
            </v-list-item>
            <v-list-item to="/delitos" class="caption">
              <b>DELITOS</b>
            </v-list-item>
            <v-list-item to="/tipo-juicios" class="caption">
              <b>TIPO JUICIOS</b>
            </v-list-item>
            <v-list-item to="/cambios-magistrado" class="caption">
              <b>CAM MAG</b>
            </v-list-item>
            <v-list-item to="/magistrados" class="caption">
              <b>MAGISTRADOS</b>
            </v-list-item>
            <v-list-item v-if="currentUser.roles[0].id == 1" to="/tocas-sin-resumen" class="caption">
              <b>TOCAS SIN RESUMEN</b>
            </v-list-item>
            <v-list-item v-if="currentUser.roles[0].id == 1" to="/resumen-jobs" class="caption">
              <b>RESUMEN JOBS</b>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu
          v-if="isLoggedIn && currentUser.roles[0].id == 3"
          bottom
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="d-flex d-sm-none"
              color="#373736"
              dark
              v-bind="attrs"
              v-on="on"
            >MENÚ</v-btn>
          </template>
          <v-list>
            <v-list-item to="/sentencias" class="caption">
              <b>SENTENCIAS</b>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-spacer></v-spacer>
        <v-menu
          v-if="isLoggedIn"
          bottom
          origin="center center"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#373736"
              dark
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>mdi-account</v-icon>
              <span class="d-none d-md-flex d-md-and-up">{{currentUser.name}}</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/updatepassword" class="caption">
              <v-icon small class="mr-2">mdi-key</v-icon>
              <b>ACTUALIZAR CONTRASEÑA</b>
            </v-list-item>
            <v-list-item @click="logout" class="caption">
              <v-icon small class="mr-2">mdi-logout</v-icon>
              <b>CERRAR SESIÓN</b>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- <v-btn icon v-if="isLoggedIn" @click="logout">
          <v-icon>mdi-logout</v-icon>
        </v-btn> -->
        <v-btn icon v-if="!isLoggedIn" to="/login">
          <v-icon>mdi-login</v-icon>
        </v-btn>
      </v-app-bar>
    </div>

    <v-main>
      <v-container class="results-graph-margin">
        <router-view></router-view>
      </v-container>
    </v-main>

    <template>
      <v-container class="results-graph-margin">
        <v-card flat>
          <v-divider style="color: #AF8936"></v-divider>
          <v-system-bar
            height="8"
            color="#AF8936"

          ></v-system-bar>
          <v-footer
            color="#FFFFFF"
            padles
          >
          <v-col class="text-center">
            <img src="@/assets/Escudo-logo.svg" width="62" height="62">
          </v-col>
            <!-- <v-col
              class="text-center"
              cols="4"
            >
              <strong>Poder Judicial</strong>
              <div><a style="color: gray" href="https://stjjalisco.gob.mx/" target="_blank">Supremo Tribunal</a></div>
              <div><a style="color: gray" href="https://cjj.gob.mx" target="_blank">C. de la Judicatura</a></div>
              <div><a style="color: gray" href="https://www.triejal.gob.mx/" target="_blank">Tribunal Electoral</a></div>
              <div><a style="color: gray" href="http://ija.gob.mx/" target="_blank">Inst. de Justicia Alternativa</a></div>
            </v-col> -->
            <!-- <v-col
              class="text-center"
              cols="4"
            >
              <strong>Transparencia</strong>
              <div><a style="color: gray">Unidad de Transparencia</a></div>
              <div><a style="color: gray" href="https://stjjalisco.gob.mx/pages/transparencia/comite_clasificacion" target="_blank">Comité de Clasificación</a></div>
              <div><a style="color: gray" href="https://stjjalisco.gob.mx/pages/transparencia/articulos" target="_blank">Transparencia</a></div>
              <div><a style="color: gray" href="https://stjjalisco.gob.mx/pages/conocenos/directorio" target="_blank">Directorio</a></div>
              <div><a style="color: gray" href="https://stjjalisco.gob.mx/pages/transparencia/ubicacion" target="_blank">Ubicación</a></div>
            </v-col>

            <v-col
              class="text-center"
              cols="4"
            >
              <strong>Solicitudes</strong>
              <div><a style="color: gray" href="https://stjjalisco.gob.mx/solicitudes" target="_blank">Nueva Solicitud de Información</a></div>
              <div><a style="color: gray" href="https://stjjalisco.gob.mx/solicitudes/sugerencias" target="_blank">Comentarios y sugerencias</a></div>
              <div><a style="color: gray" href="https://stjjalisco.gob.mx/pages/transparencia/articulos" target="_blank">Transparencia</a></div>
              <div><a style="color: gray" href="https://stjjalisco.gob.mx/pages/conocenos/directorio" target="_blank">Directorio</a></div>
              <div><a style="color: gray" href="https://stjjalisco.gob.mx/pages/transparencia/ubicacion" target="_blank">Ubicación</a></div>
            </v-col> -->
          </v-footer>
        </v-card>

      </v-container>
    </template>

  </v-app>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: false,
      itemsEstadisticas: [
        { icon: "mdi-account", text: "SENTENCIAS PUBLICADAS", link: "/estadisticas" },
        { icon: "mdi-account-question", text: "PRINCIPIO DE INTERÉS SUPERIOR", link: "/interes_superior" },
        { icon: "mdi-account-question", text: "ESTADÍSTICA REPORTES", link: "/estadistica_reporte" },
        { icon: "mdi-account-question", text: "GENERAL DE MAGISTRADOS", link: "/reporte-por-ponencia" },
        { icon: "mdi-account-question", text: "GENERAR JSON", link: "/generar-json" }
        // { divider: true },
      ],
      itemsCatalogo: [
        // { icon: "mdi-account", text: "USUARIOS", link: "/users" },
        { icon: "mdi-account-question", text: "DELITOS", link: "/delitos" },
        { icon: "mdi-account-question", text: "TIPO JUICIOS", link: "/tipo-juicios" },
        { icon: "mdi-account-question", text: "SENTIDOS", link: "/sentidos" },
        { icon: "mdi-account-question", text: "CAM MAG", link: "/cambios-magistrado" },
        { icon: "mdi-account-question", text: "MAGISTRADOS", link: "/magistrados" },
      ],
      itemsResumenIA: [
        { icon: "mdi-file-document-alert", text: "TOCAS SIN RESUMEN", link: "/tocas-sin-resumen" },
        { icon: "mdi-clipboard-text-clock", text: "JOBS (OBSERVABILIDAD)", link: "/resumen-jobs" },
      ],
      // itemsAdmin: [
      //   { heading: 'Usuarios' },
      //   { icon: "mdi-account", text: "Usuarios", link: "/users" },
      //   { icon: "mdi-account-question", text: "Roles", link: "/roles" },
      //   { icon: "mdi-key", text: "Permisos", link: "/permisos" },
      //   { divider: true },
      // ],
      // itemsAdminPerito: [
      //   { heading: 'Usuarios' },
      //   { icon: "mdi-account", text: "Usuarios", link: "/users" },
      // ],
    }),
    computed: {
      ...mapGetters(["roleUser", "isLoggedIn", "currentUser", 'permisosList'])
    },
    methods: {
      logout() {
        this.$store
          .dispatch("LOGOUT", )
          .then(() => {
            this.$swal({
              title: "Ha cerrado Sesión",
              icon: "success",
              timer: 1000
            }).then(() => {

            });
            window.location = "/login"
          })
          .catch(error => {
            this.$swal({
              title: "Error",
              text: "No se pudo Cerrar la Sesión Correctamente",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
      }
    }
  }
</script>
